export default __webpack_public_path__ + "static/media/benefit-4.9e4f0665.png";